export default __webpack_public_path__ + "b98849e793f602d429588203d0822d2f.png";